import React, { useEffect } from 'react';
import './ApiDocumentation.scss';
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import PublicApi from './PublicApi/PublicApi';
import ConsumerApi from './ConsumerApi/ConsumerApi';
import WebhooksApi from './WebhooksApi/WebhooksApi';
import BookerApi from './BookerApi/BookerApi';
import ClassesWorkflowAPI from './ClassesWorkflowAPI/ClassesWorkflowAPI';

const ApiDocumentation: React.FC = () => {

    return (         
        <div className="api-matic-landing-container">
            <Switch>
                <Route path='/ui/documentation/public-api' render={() => <PublicApi />} />
                <Route path='/ui/documentation/consumer-api' render={() => <ConsumerApi />} />
                <Route path='/ui/documentation/webhooks-api' render={() => <WebhooksApi />} />
                <Route path='/ui/documentation/booker-api' render={() => <BookerApi />} />
                <Route path='/ui/documentation/classes-workflow-api' render={() => <ClassesWorkflowAPI />} />
            </Switch>

        </div>
    );
}

export default ApiDocumentation;